import React, { useState, useEffect } from 'react';
import { Button, Form, FormGroup, Label, Input, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import Creatable, { useCreatable } from 'react-select/creatable';
import PCA_Cockpit from './PCA_Cockpit';
import Select from 'react-select';

export default function PCA_Cockpit_Parent() {

    const [stockValue, setStockValue] = useState('All');
    const [brandValue, setBrandValue] = useState('');
    const [model, setModel] = useState([]);
    const [gender, setGender] = useState([]);
    const [movement, setMovement] = useState([]);
    const [material, setMaterial] = useState([]);





    const HandleSearch = (event) => {
        event.preventDefault();
        getAllWatches()
        alert('Good Job')
    }

    const clearArray = (value) => {
        let array = []
        if (Array.isArray(value)) {
            value.forEach(element => {
                array.push(element.label)
            });
        }
        
        return array;
    }
    const stockOptions = [{ value: 0, label: 'All' }, { value: 1, label: 'Complete stock' }, { value: 2, label: 'Online stock' }, { value: 3, label: 'Workshop stock' }, { value: 4, label: 'Purchases stock' },]

    const handleStockValueChange = (value) => {
        setStockValue(clearArray(value))
    }
    
    const handleBrandValueChange = (selectedBrand) => {
        setBrandValue(selectedBrand ? selectedBrand.label : '')
    }

    const components = {
        DropdownIndicator: null,
    };
    const handleModelValueChange = (modelValue) => {
        //setModel(clearArray(modelValue))
        setModel(modelValue ? modelValue.label : '')

    }
    const genderOptions = [{ value: 0, label: 'Unisex' }, { value: 1, label: 'Men' }, { value: 2, label: 'Women' }]
    const handleGenderValueChange = (genderValue) => {
        setGender(clearArray(genderValue))
    }

    const movementOptions = [{ value: 0, label: 'automatic' }, { value: 1, label: 'manual' }, { value: 2, label: 'quartz' }]
    const handleMovementValueChange = (movementValue) => {
        setMovement(clearArray(movementValue))
    }

    const materialOptions = [{ value: 0, label: 'Rose gold' }, { value: 1, label: 'ceramic' }, { value: 2, label: 'platinium' }, { value: 3, label: 'steel' }, { value: 4, label: 'steel / gold' }, { value: 5, label: 'white gold' }, { value: 6, label: 'yellow gold' },]
    const handleMaterialValueChange = (materialValue) => {
        setMaterial(clearArray(materialValue))
    }
    useEffect(() => {
        console.log('stock stated value: ', stockValue);
        console.log('Brand value: ', brandValue);
        console.log('Model: ' , model);
        console.log('Gender: ' , gender);
        console.log('Movement: ' , movement);
        console.log('Material: ' , material);
    }, [brandValue, gender, material, model, movement, stockValue])

    const options = []
    const [brandoptions, setBrandOptions] = useState()
    const mOptions = []
    const [modeloptions, setModelOptions] = useState()


    const getBrands = async () => {
        try {
            if (brandValue) {
                
            }
            const response = await fetch(
                brandValue === '' ?
                "/api/v1/WatchHunter/Watches/SearchValues"
                : brandValue ? 
                `/api/v1/WatchHunter/Watches/SearchValues?brand=${brandValue}` : ''
                ,
                {
                    method: "get",
                    headers: new Headers({
                        "Content-Type": "application/json",
                    }),
                }
            );
            const payload = await response.json();
            payload.Brand.map((item, index) => {
                options.push({ value: index, label: item })
                setBrandOptions(options)
            })
            payload.Model.map((item, index) => {
                mOptions.push({ value: index, label: item })
                setModelOptions(mOptions)
            })
            console.log(options)
            if (!response.ok) {
                const payload = await response.text();
                alert(payload);
            }
        } catch (e) {
            console.log(e);
        }
    };

    const [allWatchesList, setAllWatchesList] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const getAllWatches = async () => {
        try {
            setIsLoading(true)
            const response = await fetch(
                "/api/v1/WatchHunter/Watches/Search",
                {
                    method: "get",
                    headers: new Headers({
                        "Content-Type": "application/json",
                    }),
                }
            );
            const payload = await response.json();
            //setApiData(payload);
            
            setAllWatchesList(payload)
            console.log(payload)
            setIsLoading(false)
            if (!response.ok) {
                const payload = await response.text();
                alert(payload);
                setIsLoading(false)
            }
        } catch (e) {
            setIsLoading(false)
            console.log(e);
        }
    };

    // useEffect(() => {

    //     getBrands();

    // }, [brandValue]);

    useEffect(() => {
        document.title = "PCA Cockpit";
        getAllWatches()
    }, []);



    return (
        <>
            <div className='shippingTable'>
                <div
                className='d-none'
                >
                    <Form inline className='shippingListHeader d-none'
                        style={
                            {
                                marginBottom: '50px',
                                display: 'none !important'
                            }
                        }
                    >
                        <Select style={{ maxHeight: '500px', overflow: 'auto', }}
                            className='w-25 mr-3 mb-2'
                            isClearable
                            isMulti
                            onChange={(value) => handleStockValueChange(value)}
                            options={stockOptions}
                            placeholder="Stock options"
                        />
                        <Creatable style={{ maxHeight: '500px', overflow: 'auto' }}
                            className='w-25 mr-3  mb-2'
                            isClearable
                            onChange={(value) => handleBrandValueChange(value)}
                            options={brandoptions}
                            placeholder="Brands"
                        />
                        <Creatable style={{ maxHeight: '500px', overflow: 'auto' }}
                            className='w-25  mb-2'
                            isClearable
                            //isMulti
                            onChange={(value) => handleModelValueChange(value)}
                            //components={components}
                            options={modeloptions}
                            placeholder="Model"
                        />
                        <Select style={{ maxHeight: '500px', overflow: 'auto', maxWidth: '200px' }}
                            className='w-25 mr-3  mb-2'
                            isClearable
                            isMulti
                            onChange={(value) => handleGenderValueChange(value)}
                            options={genderOptions}
                            placeholder="Gender options"
                        />
                        <Select style={{ maxHeight: '500px', overflow: 'auto', maxWidth: '200px' }}
                            className='w-25 mr-3  mb-2'
                            isClearable
                            isMulti
                            onChange={(value) => handleMovementValueChange(value)}
                            options={movementOptions}
                            placeholder="Movment options"
                        />
                        <Select style={{ maxHeight: '500px', overflow: 'auto', maxWidth: '200px' }}
                            className='w-25  mb-2'
                            isClearable
                            isMulti
                            onChange={(value) => handleMaterialValueChange(value)}
                            options={materialOptions}
                            placeholder="Material options"
                        />
                        <div style={{ flexBasis: '100%', textAlign: 'center', marginTop: '10px' }}>
                            <Button outline color='success' className='w-100' type="button" onClick={HandleSearch}>Search</Button>
                        </div>
                    </Form>
                </div>
                <PCA_Cockpit allWatchesList={allWatchesList} isLoading={isLoading} />
            </div>
        </>
    );
}